export const SET_MODAL_SAMPLE_VIDEO = 'SET_MODAL_SAMPLE_VIDEO';
